import React from "react";
import "./style.scss";
const PaymentQRCode = ({ qrCodeSrc }) => {
  if (qrCodeSrc) {
    return (
      <div className="payment-qr-code">
        <iframe
          frameBorder={0}
          allowTransparency={true}
          scrolling="no"
          width="100%"
          height="500px"
          src={qrCodeSrc}
        />
      </div>
    );
  } else {
    return null;
  }
};
export default PaymentQRCode;
